"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.symbol.description.js");

var _ = require("./");

class Product {
  static thaw(productObj) {
    if (productObj == null) return null;
    const product = new Product();
    if (productObj.id != null) product.setId(productObj.id);
    if (productObj.link != null) product.setLink(productObj.link);
    if (productObj.description != null) product.setDescription(productObj.description);
    if (productObj.imageUrl != null) product.setImageUrl(productObj.imageUrl);
    if (productObj.isActive != null) product.setIsActive(productObj.isActive == null ? null : productObj.isActive ? true : false);
    if (productObj.categoryId != null) product.setCategoryId(productObj.categoryId);
    if (productObj.category != null) product.setCategory(_.ProductCategory.thaw(productObj.category));
    return product;
  }

  static thawList(productObjList) {
    if (productObjList == null) return [];
    var products = [];

    for (var i = 0; i < productObjList.length; i++) {
      products.push(Product.thaw(productObjList[i]));
    }

    return products;
  }

  static freeze(product) {
    if (product == null) return null;
    var productObj = {};
    if (product.getId() != null) productObj.id = product.getId();
    if (product.getLink() != null) productObj.link = product.getLink();
    if (product.getDescription() != null) productObj.description = product.getDescription();
    if (product.getImageUrl() != null) productObj.imageUrl = product.getImageUrl();
    if (product.getIsActive() != null) productObj.isActive = product.getIsActive() == null ? null : product.getIsActive() ? 1 : 0;
    if (product.getCategoryId() != null) productObj.categoryId = product.getCategoryId();
    if (product.getCategory() != null) productObj.category = _.ProductCategory.freeze(product.getCategory());
    return productObj;
  }

  static freezeList(products) {
    if (products == null) return [];
    var productObjList = [];

    for (var i = 0; i < products.length; i++) {
      productObjList.push(Product.freeze(products[i]));
    }

    return productObjList;
  }

  constructor() {
    this.setId(null);
    this.setLink(null);
    this.setDescription(null);
    this.setImageUrl(null);
    this.setIsActive(null);
    this.setCategoryId(null);
    this.setCategory(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setLink(link) {
    this.link = link;
  }

  setDescription(description) {
    this.description = description;
  }

  setImageUrl(imageUrl) {
    this.imageUrl = imageUrl;
  }

  setIsActive(isActive) {
    this.isActive = isActive;
  }

  setCategoryId(categoryId) {
    this.categoryId = categoryId;
  }

  setCategory(category) {
    this.category = category;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getLink() {
    return this.link;
  }

  getDescription() {
    return this.description;
  }

  getImageUrl() {
    return this.imageUrl;
  }

  getIsActive() {
    return this.isActive;
  }

  getCategoryId() {
    return this.categoryId;
  }

  getCategory() {
    return this.category;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = Product;